<template>
  <app-card
    class="mt-4 text-center"
    style="width: 100%"
  >
    <div class="rounded-circle el elevation-6 mt-n12 d-inline-block pa-6 grey lighten-2">
      <v-icon
        size="80"
        color="black"
      >
        {{ icon }}
      </v-icon>
    </div>

    <v-card-text class="text-center">
      <h6 class="text-h6 mb-2 text--secondary">
        {{ title }}
      </h6>
      <slot />
    </v-card-text>
  </app-card>
</template>
<script>
  export default {
    name: 'InfinitySidebar',
    props: {
      title: String,
      icon: String,
    },
    computed: {
    },
  }
</script>
